import cx from "classnames";
import React from "react";

import { Checkbox } from "@/mk2/components/forms/Checkbox";
import useEventCallback from "@/mk2/hooks/useEventCallback";
import { slugify } from "@/mk/common/utils";

import styles from "./CheckboxWithCount.mscss";

interface OwnProps {
    className?: string;
    name: string;
    label: React.ReactNode;
    value: string;
    checked: boolean;
    count?: number;
    onChange(name: string, value: string);
}

type Props = OwnProps;

export const CheckboxWithCount: React.FunctionComponent<Props> = ({
    value,
    label,
    checked,
    name,
    onChange,
    className,
    count,
}) => {
    const onChangeCallback = useEventCallback(() => {
        onChange(name, value);
    }, [name, value, onChange]);

    return (
        <Checkbox
            className={cx(styles.CheckboxWithCount, className)}
            name={`${name}_${slugify(value)}`}
            label={
                <>
                    {name === "color" && (
                        <div
                            className={cx(
                                styles.CheckboxWithCount__color,
                                styles[`CheckboxWithCount__color--p_color-${value}`],
                            )}
                        />
                    )}
                    <span className={styles.CheckboxWithCount__label}>{label}</span>
                    <span className={styles.CheckboxWithCount__count}>{count}</span>
                </>
            }
            value={value}
            checked={checked}
            onChange={onChangeCallback}
        />
    );
};

CheckboxWithCount.displayName = "CheckboxWithCount";
